<h1>Insurance Profile</h1>
<mat-divider class="divider"></mat-divider>
<h2>Primary</h2>
<app-insurance-primary></app-insurance-primary>
<mat-divider class="divider"></mat-divider>
<h2>Dependents</h2>
<app-insurance-dependents></app-insurance-dependents>
<h2>Beneficiaries</h2>
<app-insurance-beneficiaries></app-insurance-beneficiaries>
